// components/DatePicker.tsx
import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface DatePickerProps {
  selectedDate: Date | null;
  onChange: (date: Date | null) => void;
  placeholder?: string;
  minDate?: Date;
  maxDate?: Date;
  isClearable?: boolean;
  dateFormat?: string;
  disabled?: boolean;
  label?: string;
  required?: boolean;
  error?: string;
  name?: string;
}

const DatePicker: React.FC<DatePickerProps> = ({
  selectedDate,
  onChange,
  placeholder = "Select date",
  minDate,
  maxDate,
  isClearable = false,
  dateFormat = "dd/MM/yyyy",
  disabled = false,
  label,
  required = false,
  error,
  name,
}) => {
  return (
    <div className="mb-2 row">
      {label && (
        <label htmlFor={name} className="col-form-label col-md-3">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      <div className="col-md-9">
        <ReactDatePicker
          id={name}
          selected={selectedDate}
          onChange={onChange}
          placeholderText={placeholder}
          minDate={minDate}
          maxDate={maxDate}
          isClearable={isClearable}
          dateFormat={dateFormat}
          disabled={disabled}
          className={`form-control ${error ? "is-invalid" : ""}`}
        />
        {error && <div className="invalid-feedback">{error}</div>}
      </div>
    </div>
  );
};

export default DatePicker;
